export default "__VITE_ASSET__$jEobngv__"